// Where an external seat lands after sign-in when they came in on a deal link.
// One sessionStorage key; only `/deal/<id>` paths are ever honoured, so a
// stored or typed value can never become an open redirect.
const KEY = 'bfy_post_login_next';
const ALLOWED = /^\/deal\/[A-Za-z0-9_-]+$/;

export const isAllowedNext = (path) => typeof path === 'string' && ALLOWED.test(path);

export function rememberPostLoginNext(path) {
  if (isAllowedNext(path)) sessionStorage.setItem(KEY, path);
}

// Read then remove. Returns the path only if it passes the allow-list.
export function consumePostLoginNext() {
  const v = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return isAllowedNext(v) ? v : null;
}
